module.exports = __webpack_public_path__ + "img/barrage_prize_10.3eda7a64.png";